// Perguntas e respostas contextuais do Ajudante.
// Escritas em português simples e acolhedor para pessoas 60+.

const knowledge = {
  '/painel': {
    title: 'Painel',
    questions: [
      {
        q: 'O que eu estou vendo nesta tela?',
        a: 'Esta é a sua tela principal, o Painel. Aqui você vê um resumo do seu mês: quanto você recebeu, quanto gastou e quanto sobrou. É como um espelho do seu dinheiro no mês.',
      },
      {
        q: 'O que significa aquela faixa colorida lá em cima?',
        a: 'Ela mostra como está a saúde do seu dinheiro neste mês.\n\n• Verde: tudo bem, sobrou dinheiro.\n• Amarelo: está apertado, cuidado com os gastos.\n• Vermelho: você gastou mais do que recebeu.\n\nÉ só uma dica visual, não precisa se preocupar se mudar de cor.',
      },
      {
        q: 'O que é Receita Bruta e Receita Líquida?',
        a: 'A Receita Bruta é tudo o que você recebeu, sem tirar nada.\n\nA Receita Líquida é o que sobra depois dos descontos, como INSS ou plano de saúde. É o dinheiro que realmente cai na sua conta.',
      },
      {
        q: 'O que é o Saldo Mensal?',
        a: 'É o dinheiro que sobra no fim do mês, depois de pagar todas as despesas. Se aparecer verde, você ficou no azul. Se aparecer vermelho, você gastou mais do que ganhou.',
      },
      {
        q: 'Como eu mudo o mês que estou vendo?',
        a: 'Use as setas pretas ao lado do nome do mês, no topo da tela. A seta da esquerda volta para o mês anterior e a da direita avança para o próximo. Assim você pode consultar qualquer mês.',
      },
      {
        q: 'Não aparece nada no meu painel, o que faço?',
        a: 'Isso é normal quando você ainda não cadastrou nada. Vá em Receitas para colocar o que você recebe e em Despesas para colocar o que você paga. Aí o Painel começa a mostrar seus números.',
      },
      {
        q: 'O que é aquele gráfico redondo colorido?',
        a: 'É o gráfico de Despesas por Categoria. Cada cor representa um tipo de gasto, como alimentação, saúde ou moradia. Assim você enxerga rapidinho onde está indo a maior parte do seu dinheiro.',
      },
    ],
  },

  '/receitas': {
    title: 'Receitas',
    questions: [
      {
        q: 'O que são Receitas?',
        a: 'Receita é todo o dinheiro que entra para você. Pode ser aposentadoria, salário, aluguel recebido, pensão, ajuda dos filhos, venda de algo. Tudo que chega na sua mão é receita.',
      },
      {
        q: 'Qual a diferença entre Fixa e Esporádica?',
        a: 'Fixa é o dinheiro que você recebe todo mês, sempre igual, como a aposentadoria. Ele aparece automaticamente em todos os meses.\n\nEsporádica é aquele dinheiro que entra só de vez em quando, como o 13º salário, um presente ou a venda de alguma coisa. Ele fica só no mês em que você cadastrou.',
      },
      {
        q: 'Como eu adiciono uma receita nova?',
        a: 'Toque no botão "Adicionar" na seção Receitas Fixas, se for algo que entra todo mês, ou em Receitas Esporádicas, se for algo de uma vez só. Depois preencha a descrição e o valor e toque em Salvar.',
      },
      {
        q: 'O que é Desconto?',
        a: 'Desconto é aquilo que já sai do seu dinheiro antes mesmo de chegar na sua conta. Exemplos: INSS, Imposto de Renda, plano de saúde descontado do salário. Coloque aqui para o aplicativo calcular certinho quanto sobra pra você.',
      },
      {
        q: 'O que significa "Copiar do mês anterior"?',
        a: 'É um atalho. Se você teve uma receita esporádica no mês passado e ela se repete agora, em vez de digitar tudo de novo, é só tocar nesse botão. O aplicativo traz a lista do mês passado para este mês.',
      },
      {
        q: 'Errei o valor de uma receita. Como corrigir?',
        a: 'Toque em cima da receita que você quer mudar. Vai abrir uma telinha onde você pode trocar o valor ou a descrição. Depois é só salvar. Se quiser apagar, use o botão da lixeira.',
      },
    ],
  },

  '/despesas': {
    title: 'Despesas',
    questions: [
      {
        q: 'O que são Despesas?',
        a: 'Despesas são os gastos, tudo o que você paga. Contas de luz, água, supermercado, farmácia, aluguel, internet, tudo isso é despesa. Anotando aqui, você vê certinho pra onde seu dinheiro está indo.',
      },
      {
        q: 'Qual a diferença entre Recorrente e Esporádica?',
        a: 'Recorrente é a conta que chega todo mês, como luz, água, internet e aluguel. Se você marcar como "Fixa", ela aparece automática em todos os meses.\n\nEsporádica é o gasto que acontece só uma vez, como um presente, um conserto no carro ou um remédio diferente.',
      },
      {
        q: 'O que é aquela bolinha ao lado da despesa?',
        a: 'É o marcador de "pago ou não pago".\n\n• Bolinha amarela: a conta ainda não foi paga.\n• Bolinha verde com o certinho: já está paga.\n\nÉ só tocar na bolinha para mudar. Assim você lembra o que já pagou no mês.',
      },
      {
        q: 'Como eu adiciono uma despesa?',
        a: 'Escolha a aba Recorrentes (se for conta de todo mês) ou Esporádicas (se for de uma vez só). Toque em "Adicionar", escolha a categoria (ex: saúde, moradia), escreva o que é, o valor e o dia. Depois salve.',
      },
      {
        q: 'O que é Categoria?',
        a: 'Categoria é o tipo do gasto, como Moradia, Saúde, Alimentação, Transporte. Serve para o aplicativo organizar suas contas por grupo e te mostrar onde você gasta mais. Escolha a que mais combinar na hora de cadastrar.',
      },
      {
        q: 'O que significa "5 de 10" em Pagas?',
        a: 'Quer dizer que você já pagou 5 contas das 10 que tem no mês. É só um resumo pra você saber quanto ainda falta pagar. Quando tudo estiver pago, vai aparecer, por exemplo, "10 de 10".',
      },
      {
        q: 'Tenho uma conta que chega todo mês, o que faço?',
        a: 'Cadastre na aba "Recorrentes" e deixe marcado como Fixa. Assim, todo mês ela aparece sozinha, sem você precisar digitar de novo. É só marcar como paga quando pagar.',
      },
    ],
  },

  '/metas': {
    title: 'Metas',
    questions: [
      {
        q: 'O que é uma Meta?',
        a: 'Meta é um sonho ou um objetivo que precisa de dinheiro. Pode ser uma viagem, um presente para um neto, uma reserva para emergência ou trocar o sofá. Aqui você guarda esse sonho e vê ele crescendo aos poucos.',
      },
      {
        q: 'Como eu crio uma meta nova?',
        a: 'Toque no botão "Nova Meta" no alto da tela. Escolha um tipo (viagem, saúde, casa...) ou faça uma sua. Coloque o nome, quanto você quer juntar e até quando. Depois é só salvar.',
      },
      {
        q: 'O que é "Adicionar Depósito"?',
        a: 'É quando você guardou um dinheirinho e quer somar na sua meta. Toque no botão verde "Adicionar Depósito", coloque o valor que guardou e pronto. A barrinha vai andar um pouquinho mais perto do seu sonho.',
      },
      {
        q: 'O que é a barrinha colorida?',
        a: 'É a barra de progresso. Ela mostra o quanto você já juntou e o quanto ainda falta. Quando a barra chegar no final, quer dizer que você conseguiu alcançar a sua meta. Vai aparecer "Meta alcançada!" e uma marquinha verde.',
      },
      {
        q: 'O que quer dizer "Contribuição Mensal"?',
        a: 'É mais ou menos quanto você precisaria guardar por mês para chegar na sua meta na data que você escolheu. É só uma sugestão, não é obrigado. Se não der num mês, tudo bem, você guarda no próximo.',
      },
      {
        q: 'Posso ter mais de uma meta ao mesmo tempo?',
        a: 'Pode sim. Você pode ter várias metas juntas, uma para cada sonho. Por exemplo: uma para uma viagem, outra para a reserva de emergência e outra para um presente. Cada uma vai aparecer num quadrinho separado.',
      },
    ],
  },

  '/relatorios': {
    title: 'Relatórios',
    questions: [
      {
        q: 'Para que servem os Relatórios?',
        a: 'Aqui você vê o seu ano inteiro de uma vez só. Dá para saber em qual mês sobrou mais dinheiro, em qual mês apertou e como estão suas finanças no geral. Também tem uma calculadora pra planejar investimentos.',
      },
      {
        q: 'Como mudo o ano do relatório?',
        a: 'Na aba "Relatório Anual", procure a caixinha com o ano no topo. Toque nela e escolha o ano que você quer ver. O relatório todo vai se ajustar automaticamente para aquele ano.',
      },
      {
        q: 'O que é "Melhor Mês" e "Pior Mês"?',
        a: 'Melhor Mês é aquele em que sobrou mais dinheiro para você. Pior Mês é aquele em que sobrou menos ou faltou. Ajuda a entender em quais meses do ano você costuma gastar mais, como datas de festa ou fim de ano.',
      },
      {
        q: 'O que é aquele gráfico de barras?',
        a: 'É a "Evolução Mensal". Cada mês tem três barrinhas: o que você recebeu, o que gastou e o que sobrou. Assim você compara os meses rapidinho, sem precisar fazer conta.',
      },
      {
        q: 'Para que serve a Calculadora?',
        a: 'Ela ajuda a imaginar quanto o seu dinheiro pode crescer se você guardar um pouquinho todo mês. Você coloca o valor inicial, quanto pretende guardar por mês e por quantos anos. Ela mostra o resultado, sem compromisso.',
      },
      {
        q: 'O que são "juros compostos"?',
        a: 'É o seguinte: quando você guarda dinheiro, ele rende um pouquinho. No mês seguinte, esse pouquinho também começa a render. Com o tempo, o dinheiro vai crescendo sozinho, como uma bolinha de neve. Por isso vale a pena começar cedo.',
      },
      {
        q: 'Não precisa ser exato na calculadora?',
        a: 'Não. É só uma simulação para você ter uma ideia. Os juros reais podem ser um pouco diferentes, mas serve bem para planejar e para sonhar. Brinque com os valores à vontade.',
      },
    ],
  },

  '/ajustes': {
    title: 'Ajustes',
    questions: [
      {
        q: 'O que eu posso fazer nesta tela?',
        a: 'Aqui você muda coisas do seu aplicativo: seu nome, seu avatar (aquela carinha que aparece no topo), sua senha e outras preferências. É a sua área pessoal.',
      },
      {
        q: 'Como aumento o tamanho das letras do aplicativo?',
        a: 'No topo da tela, perto do nome do aplicativo, tem dois botões escritos "A". O "A+" aumenta a letra e o "A-" diminui. Toque até ficar no tamanho que fica bom para você.',
      },
      {
        q: 'Como troco meu avatar?',
        a: 'É aquela figurinha que aparece ao lado do seu nome. Na tela de ajustes, procure a opção de avatar, toque e escolha a carinha que você gostar mais. É só para deixar o aplicativo com a sua cara.',
      },
      {
        q: 'E se eu quiser sair do aplicativo?',
        a: 'No topo da tela, tem um botão vermelho com uma setinha para fora. Esse é o botão Sair. Toque nele quando quiser fechar sua conta. Da próxima vez, é só entrar de novo com seu e-mail e senha.',
      },
      {
        q: 'Posso mudar minha senha?',
        a: 'Pode. Procure a opção de alterar senha nesta tela. Vai pedir a senha antiga e a nova. Escolha uma senha que você lembre, mas que seja difícil de outra pessoa adivinhar.',
      },
    ],
  },
};

export function getKnowledgeForPath(pathname) {
  return knowledge[pathname] || null;
}

export default knowledge;
